import { ServicesManager } from '@core';
import { useViewportGrid } from '@ui';

export const useGetDisplaysetModality = (servicesManager: ServicesManager) => {
	const { displaySetService } = servicesManager.services;
	const [{ viewports, activeViewportId }] = useViewportGrid();
	const activeViewport = viewports.get(activeViewportId);
	const displaySet =
		displaySetService &&
		activeViewport &&
		activeViewport.displaySetInstanceUIDs &&
		activeViewport.displaySetInstanceUIDs &&
		activeViewport.displaySetInstanceUIDs.length &&
		activeViewport.displaySetInstanceUIDs[0]
			? displaySetService.getDisplaySetByUID(activeViewport.displaySetInstanceUIDs[0])
			: undefined;

	// Modality of current displaySet
	const modality = displaySet?.Modality;

	return modality;
};
